import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Tuvalu: Country = {
    identifier: "Tuvalu",
    name: "Tuvalu",
    countryCode: "TV",
    group: CountryGroup.OCEANIA,
    isUNMember: true,
    flag: "🇹🇻",
    svgPath: "m 972.47375,479.9984 -0.016,10e-4 -0.025,-0.013 -0.009,-0.029 0.009,-0.028 0.068,0.046 -0.027,0.023 z m -2.761,0.472 -0.016,0.018 -0.021,-0.009 -0.01,-0.029 0.03,-0.041 0.017,0.061 z m 6.707,3.35 -0.017,0.025 -0.02,-0.009 0,-0.037 0.037,0.021 z m 1.461,3.038 -0.025,0.02 -0.03,-0.27 0.045,0.046 0.019,0.029 0.017,0.036 0.004,0.038 -0.002,0.042 -0.01,0.028 -0.018,0.031 z",
}
